var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanySigner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.42186 10.8894C2.37695 11.0874 2.4562 11.2928 2.62242 11.4094C2.78864 11.5259 3.00883 11.5304 3.17965 11.4207L5.99974 9.6097L8.81983 11.4207C8.99064 11.5304 9.21083 11.5259 9.37705 11.4094C9.54327 11.2928 9.62253 11.0874 9.57762 10.8894L8.80236 7.47164L11.3346 5.19134C11.4827 5.05794 11.5375 4.8493 11.4739 4.66036C11.4103 4.47142 11.2406 4.33829 11.042 4.32155L7.74122 4.04354L6.46469 0.8161C6.38923 0.625323 6.20489 0.5 5.99974 0.5C5.79458 0.5 5.61024 0.625323 5.53478 0.8161L4.25825 4.04355L0.958029 4.32155C0.759395 4.33829 0.589677 4.47141 0.526107 4.66034C0.462537 4.84927 0.517262 5.05791 0.665378 5.19131L3.19712 7.47161L2.42186 10.8894Z",
    fill: "#FFAB00",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanySigner);
export default __webpack_public_path__ + "static/media/companySigner.85b2c7f9c68aa4b4b47756c2c7195b3a.svg";
export { ForwardRef as ReactComponent };